/**
 * GeChiUI dependencies
 */
import { useContext } from '@gechiui/element';

/**
 * Internal dependencies
 */
import { OnCaretVerticalPositionChange } from '../block-list';

export function useNativeProps() {
	return {
		onCaretVerticalPositionChange: useContext(
			OnCaretVerticalPositionChange
		),
	};
}
